<template>
  <!-- <div style="text-align: center; margin-top: 60px">
    <h1>欢迎来到商贾供应链管理平台！</h1>
  </div> -->
  <el-row class="mainTableBox" :gutter="20" style="padding: 20px;">
      <el-col :span="2"><div class="dtitle"><Bell class="dicon"/>公告</div></el-col>
      <el-col :span="20">
        <template  v-for="item in noticeData" :key="item.noticeid">
        <el-link type="danger" @click="open('noticeDetail',item.noticeid)" target="_blank" style="margin-right: 40px;"><MagicStick class="dicon"/>{{ item.title.substr(0,15) }}...</el-link>
      </template>
      </el-col>
      <el-col :span="2" style="text-align: right;">
        <el-link @click="open('noticeList','more')" target="_blank">更多<el-icon class="el-icon--right"><DArrowRight /></el-icon></el-link>
      </el-col>
  </el-row>


  <el-row class="mainTableBox" >
      <el-col :span="24" class="mpadding">
        <div class="dtitle">商贾版本</div>
        <el-divider />
        <!-- <el-alert title="交纳平台服务费用，享受核心功能！" type="success" :closable="false" /> -->
        <el-row>
          <el-col :span="24">
          <table class="versionBox" border="0" cellpadding="0" cellspacing="0" style="text-align: center" >
            <tr>
              <td class="trtitle">模块</td>
              <td class="trtitle" style="width:120px">功能</td>
              <td style="height: 160px; vertical-align: top;"><div class="title">免费版</div>
                <div><el-button class="span11" type="danger" size="large" text>¥ 0</el-button>元</div>
                <div>
                <span style="margin-top:15px;color: #f56c6c;display: block;font-size:14px;">免费使用</span>
              </div></td>
              <td style="height: 160px; vertical-align: top;">
                <div class="title">旗舰版</div>
                <div><el-button class="span11" type="danger" size="large" text>¥ 3600/年</el-button>元</div>
                <div>
                <el-button type="danger" @click="openFee" style="margin:15px 0">立即交纳平台会员费</el-button>
                <!-- <br/> -->
                <!-- <el-text type="danger">交纳完成后，发送汇款凭证给工作人员。<br/>服务电话：177-1707-8299（同微信）</el-text> -->
              </div>
              </td>
              <td style="height: 160px; vertical-align: top;"><div class="title"><el-badge value="推荐">私有版</el-badge></div>
                <div><el-button class="span11" type="danger" size="large" text>咨询顾问</el-button></div>
                <div><span style="margin-top:15px;color: #f56c6c;display: block;font-size:14px;">服务电话：177-1707-8299（同微信）</span></div>
              </td>
            </tr>
            <tr>
              <td class="trtitle">商品</td>
              <td>基础</td>
              <td><el-button type="primary" :icon="Select" plain circle size="small"/></td>
              <td><el-button type="primary" :icon="Select" plain circle size="small"/></td>
              <td><el-button type="primary" :icon="Select" plain circle size="small"/></td>
            </tr>
            <tr>
              <td></td>
              <td>导出商品</td>
              <td><el-button type="warning" :icon="CloseBold" plain circle size="small"/></td>
              <td><el-button type="primary" :icon="Select" plain circle size="small"/></td>
              <td><el-button type="primary" :icon="Select" plain circle size="small"/></td>
            </tr>
            <tr>
              <td></td>
              <td>导入过渡商品</td>
              <td><el-button type="warning" :icon="CloseBold" circle plain size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain size="small"/></td>
            </tr>
            <tr>
              <td class="trtitle">订单</td>
              <td>基础</td>
              <td><el-button type="primary" :icon="Select" circle plain size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain size="small"/></td>
            </tr>
            <tr>
              <td></td>
              <td>导入快递单号</td>
              <td><el-button type="warning" :icon="CloseBold" circle plain size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain size="small"/></td>
            </tr>
            <tr>
              <td></td>
              <td>按供应商（发货模块）导出</td>
              <td><el-button type="warning" :icon="CloseBold" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            <tr>
              <td></td>
              <td>按快递单号导出</td>
              <td><el-button type="warning" :icon="CloseBold" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            <tr>
              <td class="trtitle">售后</td>
              <td>基础</td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            <tr>
              <td></td>
              <td>导出售后</td>
              <td><el-button type="warning" :icon="CloseBold" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            <tr>
              <td class="trtitle">账务</td>
              <td>基础</td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            <tr>
              <td></td>
              <td>导出对账</td>
              <td><el-button type="warning" :icon="CloseBold" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            <tr>
              <td class="trtitle">经营</td>
              <td>基础</td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            <tr>
              <td></td>
              <td>全部统计导出</td>
              <td><el-button type="warning" :icon="CloseBold" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            <tr>
              <td></td>
              <td>全部排行导出</td>
              <td><el-button type="warning" :icon="CloseBold" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            <tr>
              <td class="trtitle">客户</td>
              <td>基础</td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            <tr>
              <td></td>
              <td>导出客户</td>
              <td><el-button type="warning" :icon="CloseBold" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            <tr>
              <td class="trtitle">供应商</td>
              <td>基础</td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            <tr>
              <td></td>
              <td>导出供应商</td>
              <td><el-button type="warning" :icon="CloseBold" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
           
            <tr>
              <td class="trtitle">类目</td>
              <td>基础</td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            <tr>
              <td></td>
              <td>导出类目</td>
              <td><el-button type="warning" :icon="CloseBold" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            <tr>
              <td class="trtitle">品牌</td>
              <td>基础</td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            <tr>
              <td></td>
              <td>导出品牌</td>
              <td><el-button type="warning" :icon="CloseBold" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            <tr>
              <td class="trtitle">营销-项目</td>
              <td>全部</td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            <tr>
              <td class="trtitle">营销-任务</td>
              <td>全部</td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            
            <tr>
              <td class="trtitle">营销-审阅</td>
              <td>全部</td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            
            <tr>
              <td class="trtitle">营销-报表</td>
              <td>全部</td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            <tr>
              <td class="trtitle">系统设置</td>
              <td>全部</td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
              <td><el-button type="primary" :icon="Select" circle plain  size="small"/></td>
            </tr>
            
           
          </table>
          
          </el-col>


    </el-row>

        
    </el-col>
  </el-row>

  <el-row class="mainTableBox" >
      <el-col :span="24" class="mpadding" style="padding-bottom: 100px;">
        <div class="dtitle"><Guide class="dicon"/>新手经营指导</div>
        <el-divider />
        <el-steps :active="5">
            <el-step title="基础字典" description="客户、供应商、类目、品牌、用户权组、权限设置" />
            <el-step title="商品入库" description="商品过渡库导入、商品库导入；在第三方平台添加商品时请把商贾平台商品ID入库" />
            <el-step title="订单入库" description="订单导入时，导入模块中商品编码手填SKU是商品ID" />
            <el-step title="售后订单" description="对订单进行售后操作" />
            <el-step title="账务对账" description="客户对账，供应商对账" />
        </el-steps>
    </el-col>
  </el-row>


</template>

<script setup>
import { ElMessageBox } from 'element-plus'
import useClipboard from 'vue-clipboard3';
import { ref,onMounted } from "vue";
import { useRouter } from "vue-router";

import { listNotice } from "@/api/notice";

import {
  CloseBold,
  Select
  
} from '@element-plus/icons-vue'

const router = useRouter();
let open = (routeName, row) => {
  console.log(row)
  if (row === 'more') {
    router.push({
      name: routeName,
    });
  } else {
    router.push({
      name: routeName,
      params: { id: row },
    });
  }
};

const noticeData = ref()

const getListNotice = () => {
  let postData = {
    status:1,
    pageNo:1,
    pageSize:3
  }
  listNotice(postData).then((res) => {    
    noticeData.value = res.data.extend.pages.list;
  });
};


//onMounted方法
onMounted(() => {
  getListNotice();
});

const { toClipboard } = useClipboard();

const openFee = () => {
  ElMessageBox.alert(
    '<div>开户银行：<strong>上海农村商业银行股份有限公司松江支行</strong></div><div>账户名称：<strong>上海从谷科技有限公司</strong></div> <div>银行账号：<strong>50131000951155777</strong></div><div style="color:#f56c6c;font-size:13px;">交纳完成后，发送汇款凭证给工作人员，<br/>服务电话：177-1707-8299（同微信）。</div> ',
    '从谷科技汇款账号',
    {
      confirmButtonText: '复制',
      dangerouslyUseHTMLString: true,
      callback: (action) => {
        console.log('----action',action)
        toClipboard("开户银行：上海农村商业银行股份有限公司松江支行\n账户名称：上海从谷科技有限公司\n银行账号：50131000951155777");
      },
    }
  )
}
</script>

<style scoped>
    .mainTableBox {
        margin-bottom: 15px;
    }
    .dtitle {
        font-weight:400;
        font-size: 18px;
    }
    .dctitle {
        font-weight: bold;
        margin-left: 20px;
        padding-top: 15px;
        display: inline-block;
    }
    .dicon {
        width: 1em; height: 1em; margin-right: 5px;vertical-align:-3px
    }
    .el-button--large span {
      font-size: 24px;
    }
    .span1 {
        font-size: 16px;
        padding-right: 10px;
        color: #f56c6c;
    }
    .span11 {
        font-size: 24px;
    }
    .span2 {
        padding:0 10px;
        font-size: 24px;
    }
    .el-tag {
      margin: 0 5px;
    }
    .trtitle {
      font-weight: bold;
    }
  </style>